import { Component } from '@angular/core';

@Component({
  selector: 'broker-warning-svg',
  templateUrl: './warning-svg.component.svg'
})
export class WarningSvgComponent {}
